import React from "react";
import { useAccountingMigration } from "@api/accountingIntegration.api";
import { fullDateFullYearFormat } from "@common/helpers/date";
import { formatDateOnly } from "@helpers/date";
import { useCanManageWorkspace } from "@hooks/permissions/useCanManageWorkspace";
import { useActiveWorkspace } from "@hooks/useActiveWorkspace";
import { useEntity } from "../../entity/useEntity";
import { SettingRow } from "../General/SettingRow";
import styles from "./EntityGeneralSettings.module.scss";

const BOOKKEEPING_START_DATE_DOCS_LINK =
    "https://docs.kick.co/setting-up/bookkeeping-start-date";

export const EntityBookkeepingStartDateRow: React.FC<{
    onEdit: () => void;
}> = ({ onEdit }) => {
    const entity = useEntity();
    const workspace = useActiveWorkspace();
    const canManageWorkspace = useCanManageWorkspace();
    const accountingMigration = useAccountingMigration(
        workspace?.id ?? null,
        entity.id,
    );
    const isMigrated = Boolean(accountingMigration.data);
    const canEdit =
        canManageWorkspace && !accountingMigration.isLoading && !isMigrated;

    return (
        <SettingRow
            label="Bookkeeping start date"
            value={
                <>
                    {formatDateOnly(
                        entity.bookkeepingStartDate,
                        fullDateFullYearFormat,
                    )}
                    <span className={styles.hint}>
                        Kick keeps books from this date. Transactions before it
                        are excluded.
                        {canManageWorkspace &&
                            isMigrated &&
                            " Contact support to change this date."}{" "}
                        <a
                            href={BOOKKEEPING_START_DATE_DOCS_LINK}
                            target="_blank"
                            rel="noreferrer"
                        >
                            Learn more
                        </a>
                    </span>
                </>
            }
            buttonText="Edit start date"
            onButtonClick={canEdit ? onEdit : undefined}
        />
    );
};
